import { post } from './queryPortal';


function isJsonString(str) {
  try { JSON.parse(str); } catch (e) { return false; }
  return true;
}

export function getCustomizationValidation(columns) {
  if (!columns) {
    return {};
  }
  const validationBySection = columns.reduce((acc, item) => {
    if (item.section_name && item.config && item.visible == '1') {
      acc[item.section_name] = {
        ...acc[item.section_name],
        [item.column_name]: {
          ...item.config,
          column_name: item.column_name,
        },
      };
    }

    return acc;
  }, {});

  return validationBySection;
}

export function getCustomizationFields(columns) {
  // console.log('cols:', columns);
  const typeMap = { datetime: 'date', numeric: 'number', int: 'number', nvarchar: 'string' };
  columns.forEach(field => {
    field.config = (isJsonString(field.config) ? JSON.parse(field.config) : field.config) || {};
    field.config.inputType = field.config.inputType || field && typeMap[field.data_type];
    field.config.maxLength = field && parseInt(field.data_length) > 0 ? parseInt(field.data_length) : undefined;
  });
  return columns;
}

export const getDoubleClick = (doubleClickOptions) => {
  return doubleClickOptions.reduce((acc, item) => {
    const entity = item.column_name;

    if (entity) {
      if (!acc[entity]) {
        acc[entity] = [];
      }

      acc[entity].push(item);
    }

    return acc;
  }, {})
};
